module.exports = __webpack_public_path__ + "5ebb5332304fa1ebc7311567cebb6022.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/images/ic_session_active_24.svg
// module id = 1087
// module chunks = 3